export enum FranchisorAddressTypeEnum {
  LEGAL = 'LEGAL',
  ACTUAL = 'ACTUAL',
  POSTAL = 'POSTAL',
  OTHER = 'OTHER',
}
